var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13.933,
    viewBox: "0 0 15 13.933",
    fill: "var(--icon-fill)",
    stroke: "var(--icon-stroke)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.227h2.545V6.591H1.5zm14-7a1.276 1.276 0 0 0-1.273-1.273h-4.015l.6-2.908.019-.2a.958.958 0 0 0-.28-.675l-.67-.671-4.187 4.194a1.244 1.244 0 0 0-.375.9v6.364a1.276 1.276 0 0 0 1.273 1.273h5.727a1.264 1.264 0 0 0 1.171-.776l1.922-4.486A1.257 1.257 0 0 0 15.5 8.5V7.285l-.006-.006z",
    transform: "translate(-1 -.794)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.0dddc813d68260269dd93b2912d33d14.svg";
export { ForwardRef as ReactComponent };